/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeWithAvailabilityAvailablePeriod
 */
export interface EmployeeWithAvailabilityAvailablePeriod {
    /**
     * Start datetime of the period of availability.
     * @type {Date}
     * @memberof EmployeeWithAvailabilityAvailablePeriod
     */
    startsAt: Date;
    /**
     * End datetime of the period of availability.
     * @type {Date}
     * @memberof EmployeeWithAvailabilityAvailablePeriod
     */
    endsAt: Date;
}

/**
 * Check if a given object implements the EmployeeWithAvailabilityAvailablePeriod interface.
 */
export function instanceOfEmployeeWithAvailabilityAvailablePeriod(value: object): value is EmployeeWithAvailabilityAvailablePeriod {
    if (!('startsAt' in value) || value['startsAt'] === undefined) return false;
    if (!('endsAt' in value) || value['endsAt'] === undefined) return false;
    return true;
}

export function EmployeeWithAvailabilityAvailablePeriodFromJSON(json: any): EmployeeWithAvailabilityAvailablePeriod {
    return EmployeeWithAvailabilityAvailablePeriodFromJSONTyped(json, false);
}

export function EmployeeWithAvailabilityAvailablePeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeWithAvailabilityAvailablePeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'startsAt': (new Date(json['startsAt'])),
        'endsAt': (new Date(json['endsAt'])),
    };
}

  export function EmployeeWithAvailabilityAvailablePeriodToJSON(json: any): EmployeeWithAvailabilityAvailablePeriod {
      return EmployeeWithAvailabilityAvailablePeriodToJSONTyped(json, false);
  }

  export function EmployeeWithAvailabilityAvailablePeriodToJSONTyped(value?: EmployeeWithAvailabilityAvailablePeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startsAt': ((value['startsAt']).toISOString()),
        'endsAt': ((value['endsAt']).toISOString()),
    };
}

